import React, { Component } from "react";
import "./Render.css";

import Belgie from "./Belgie";

class Render extends Component {
  constructor(props) {
    super(props);
    this.myRef = React.createRef();
  }

  save = () => {
    var element = document.getElementById("weerpancarte");
    var link = document.createElement("a");
    link.download = "test.png";
    link.href = element.toDataURL();
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    var element2 = document.getElementById("overzicht");
    var link2 = document.createElement("a");
    link2.download = "overzicht.png";
    link2.href = element2.toDataURL();
    document.body.appendChild(link2);
    link2.click();
    document.body.removeChild(link2);
  };

  render() {
    return (
      <div>
        <div className="rendertekst">
          <div onClick={this.save}>opslaan</div>
          <Belgie channel="tvo" />
        </div>
      </div>
    );
  }
}

export default Render;
